<div class="image-container">
    <img [src]="'assets/images/empty-state/'+(currentTheme === CssThemes.SUPER_ADMIN ? CssThemes.MODDAKIR : currentTheme)+'.png'" alt="empty-state">
</div>